export const DISABLE_ESLINT_PLUGIN = "true";
export const REACT_APP_NODE_ENV = "prod";
export const preStaticUrl = "";